import _jsx from "@babel/runtime/helpers/jsx";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onClose"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { isFormHasUnsavedChanges, isWarningAccepted } from '../helpers';
import history from '../history';
import warningMessages from '../helpers/warningMessages';
import AppContext from '../context';
export default function (WrappedComponent) {
  var _dec, _class, _class2;
  var Wrap = (_dec = connect(function (state) {
    return {
      allForms: state.form
    };
  }), injectIntl(_class = _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    _inherits(Wrap, _React$Component);
    var _super = _createSuper(Wrap);
    function Wrap() {
      var _this;
      _classCallCheck(this, Wrap);
      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(_args));
      _defineProperty(_assertThisInitialized(_this), "state", {
        formSaved: false
      });
      _defineProperty(_assertThisInitialized(_this), "unblock", null);
      _defineProperty(_assertThisInitialized(_this), "onBeforeUnload", function (e) {
        var message;
        if (_this.isPageUnsaved()) {
          message = _this.getWarningMessage();
          e.returnValue = message;
        }
        return message;
      });
      _defineProperty(_assertThisInitialized(_this), "getWarningMessage", function () {
        return _this.props.intl.formatMessage(warningMessages.onWindowRedirectWarningMessage);
      });
      _defineProperty(_assertThisInitialized(_this), "setListeners", function () {
        window.addEventListener('beforeunload', _this.onBeforeUnload);
        _this.setHistoryListener();
      });
      _defineProperty(_assertThisInitialized(_this), "setImgLoading", function (isLoading) {
        _this.isImgLoading = isLoading;
      });
      _defineProperty(_assertThisInitialized(_this), "setHistoryListener", function () {
        _this.unblock = history.block(function () {
          var message;
          if (_this.isPageUnsaved()) {
            message = _this.getWarningMessage();
          }
          return message;
        });
      });
      _defineProperty(_assertThisInitialized(_this), "isPageUnsaved", function () {
        return _this.isImgLoading() || !_this.isAllFormsSaved();
      });
      _defineProperty(_assertThisInitialized(_this), "isImgLoading", function () {
        return false;
      });
      _defineProperty(_assertThisInitialized(_this), "removeListeners", function () {
        _this.unblock();
        window.removeEventListener('beforeunload', _this.onBeforeUnload);
      });
      _defineProperty(_assertThisInitialized(_this), "isCurrentFormCanExit", function () {
        if (_this.state.formSaved) {
          return true;
        }
        var hasChanges = isFormHasUnsavedChanges({
          formName: _this.props.form,
          allForms: _this.props.allForms
        });
        return !hasChanges && !_this.isImgLoading() || isWarningAccepted(_this.getWarningMessage());
      });
      _defineProperty(_assertThisInitialized(_this), "isAllFormsSaved", function () {
        var forms = Object.keys(_this.props.allForms);
        if (forms.length === 1 && _this.state.formSaved) {
          return true;
        }
        for (var i = 0; i < forms.length; i += 1) {
          if (isFormHasUnsavedChanges({
            formName: forms[i],
            allForms: _this.props.allForms
          })) {
            return false;
          }
        }
        return true;
      });
      _defineProperty(_assertThisInitialized(_this), "handleFormClose", function () {
        if (_this.isCurrentFormCanExit()) {
          _this.props.onClose();
        }
      });
      _defineProperty(_assertThisInitialized(_this), "handleAfterSave", function () {
        _this.setState({
          formSaved: true
        });
        if (_this.props.afterSave) {
          var _this$props;
          (_this$props = _this.props).afterSave.apply(_this$props, arguments);
        }
      });
      _defineProperty(_assertThisInitialized(_this), "handleOnSave", function () {
        _this.setState({
          formSaved: true
        });
        if (_this.props.onSave) {
          var _this$props2;
          (_this$props2 = _this.props).onSave.apply(_this$props2, arguments);
        }
      });
      _defineProperty(_assertThisInitialized(_this), "getContextValue", function () {
        return _objectSpread(_objectSpread({}, _this.context || {}), {}, {
          checkImgLoading: _this.setImgLoading
        });
      });
      return _this;
    }
    _createClass(Wrap, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.context.onEscapePress) {
          this.context.onEscapePress(this.handleFormClose);
        }
        this.setListeners();
        window.addEventListener('remove_beforeunload', this.removeListeners);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.removeListeners();
        this.setState({
          formSaved: false
        });
        window.removeEventListener('remove_beforeunload', this.removeListeners);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
          onClose = _this$props3.onClose,
          props = _objectWithoutProperties(_this$props3, _excluded);
        return /*#__PURE__*/_jsx(AppContext.Provider, {
          value: this.getContextValue()
        }, void 0, /*#__PURE__*/React.createElement(WrappedComponent, _extends({
          formName: this.props.form,
          onClose: this.handleFormClose
        }, props, {
          afterSave: this.handleAfterSave,
          onSave: this.handleOnSave
        })));
      }
    }]);
    return Wrap;
  }(React.Component), _defineProperty(_class2, "defaultProps", {
    onClose: function onClose() {},
    afterSave: function afterSave() {},
    onSave: function onSave() {}
  }), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class);
  return Wrap;
}